import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class CostharegionInsertService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	constructor(private http: Http) { }

	insertCost(token, data: any) {

		console.log(data);

		return this.http
		.post(this.apiUrl + "costharegion/v1/insertcostharegion", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/costharegion/service/costharegion-insert/costharegion-insert.service.ts